"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}, _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM11.3328 8L6.62784 11.2192V4.7808L11.3328 8ZM5.62784 4.14052C5.62784 3.61796 6.25799 3.31608 6.7072 3.62343L12.3479 7.48291C12.7211 7.73824 12.7211 8.26176 12.3479 8.51709L6.7072 12.3766C6.25799 12.6839 5.62784 12.382 5.62784 11.8595V4.14052Z"
}));

exports.default = _default;